module.exports = __webpack_public_path__ + "static/img/nanoscience_1.20e5653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/nanoscience_1.png
// module id = wj/0
// module chunks = 6